module.exports = __webpack_public_path__ + "img/blank-comic-book_B098PPWJDW.222153ef.jpg";